import CategoryCreate from './category/CategoryCreate'
import CategoryEdit from './category/CategoryEdit'
import CategoryIndex from './category/CategoryIndex'
import ConfirmPassword from './auth/ConfirmPassword'
import CustomRuleCreate from './project/rule/CustomRuleCreate'
import CustomRuleEdit from './project/rule/CustomRuleEdit'
import DashboardPage from './Dashboard'
import ErrorPage from './static/error/Error'
import FlexibleRuleEdit from './project/rule/FlexibleRuleEdit'
import FirstLoginPage from './auth/FirstLogin'
import InformationPage from './InformationPage'
import ManualsPage from './ManualsPage'
import MapEdit from './map/Edit'
import MapImport from './map/Import'
import MapGroupEdit from './mapGroup/Edit'
import MapGroupIndex from './mapGroup/Index'
import NotificationIndex from './notification/NotificationIndex'
import NotificationSettings from './notification/NotificationSettings'
import ObjectCatalog from './object/ObjectCatalog'
import ObjectCreate from './object/ObjectCreate'
import ObjectEdit from './object/ObjectEdit'
import ObjectIndex from './object/ObjectIndex'
import ObjectGroupCreate from './object/group/ObjectGroupCreate'
import ObjectGroupEdit from './object/group/ObjectGroupEdit'
import ObjectGroupIndex from './object/group/ObjectGroupIndex'
import ObjectShow from './object/ObjectShow'
import PhaseCreate from './phase/PhaseCreate'
import PhaseEdit from './phase/PhaseEdit'
import PhaseIndex from './phase/PhaseIndex'
import PrivacyStatement from './PrivacyStatement'
import ProfilePage from './auth/Profile'
import ProjectCategoryEdit from './project/category/CategoryEdit'
import ProjectMapEdit from './project/map/MapEdit'
import ProjectIndex from './project/ProjectIndex'
import ProjectImportIndex from './project/import/ProjectImportIndex'
import ProjectImportShow from './project/import/ProjectImportShow'
import ProjectObjectEdit from './project/object/ProjectObjectEdit'
import ProjectObjectShow from './project/object/ProjectObjectShow'
import ProjectRuleIndex from './project/rule/RuleIndex'
import ProjectRuleShow from './project/rule/RuleShow'
import ProjectEdit from './project/ProjectEdit'
import ProjectShow from './project/ProjectShow'
import RegisterPage from './auth/Register'
import ResetPage from './auth/Reset'
import RoleCreate from './role/RoleCreate'
import RoleEdit from './role/RoleEdit'
import RoleIndex from './role/RoleIndex'
import RuleCatalog from './rule/RuleCatalog'
import RuleCreate from './rule/RuleCreate'
import RuleEdit from './rule/RuleEdit'
import RuleExportImport from './rule/RuleExportImport.vue'
import RuleIndex from './rule/RuleIndex'
import RuleShow from './rule/RuleShow'
import SearchPage from './search/SearchPage'
import SignupPage from './auth/Signup'
import SubcategoryCreate from './category/SubcategoryCreate'
import SubcategoryEdit from './category/SubcategoryEdit'
import ThemeCreate from './theme/ThemeCreate'
import ThemeEdit from './theme/ThemeEdit'
import ThemeIndex from './theme/ThemeIndex'
import TwoFactorChallenge from './auth/TwoFactorChallenge'
import UserCreate from './user/UserCreate'
import UserEdit from './user/UserEdit'
import UserIndex from './user/UserIndex'
import WelcomePage from './WelcomePage'

export default {
  CategoryCreate,
  CategoryEdit,
  CategoryIndex,
  ConfirmPassword,
  CustomRuleCreate,
  CustomRuleEdit,
  DashboardPage,
  ErrorPage,
  FlexibleRuleEdit,
  FirstLoginPage,
  InformationPage,
  NotificationIndex,
  NotificationSettings,
  ObjectCatalog,
  ObjectCreate,
  ObjectEdit,
  ObjectIndex,
  ObjectGroupCreate,
  ObjectGroupEdit,
  ObjectGroupIndex,
  ObjectShow,
  PhaseCreate,
  PhaseEdit,
  PhaseIndex,
  ManualsPage,
  MapEdit,
  MapImport,
  MapGroupEdit,
  MapGroupIndex,
  ProfilePage,
  ProjectCategoryEdit,
  ProjectIndex,
  ProjectMapEdit,
  ProjectObjectEdit,
  ProjectObjectShow,
  ProjectRuleIndex,
  ProjectRuleShow,
  ProjectImportIndex,
  ProjectImportShow,
  ProjectEdit,
  ProjectShow,
  RegisterPage,
  ResetPage,
  RoleCreate,
  RoleEdit,
  RoleIndex,
  RuleCatalog,
  RuleCreate,
  RuleEdit,
  RuleExportImport,
  RuleIndex,
  RuleShow,
  PrivacyStatement,
  SearchPage,
  SignupPage,
  SubcategoryCreate,
  SubcategoryEdit,
  ThemeCreate,
  ThemeEdit,
  ThemeIndex,
  TwoFactorChallenge,
  UserCreate,
  UserEdit,
  UserIndex,
  WelcomePage,
}
